module.exports = __webpack_public_path__ + "img/icon_shopping_basket.2c0ffd94.svg";